import React from 'react';

export default {
  svg: (
    <g id="Pre-Visit-Forms/R1" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g
        id="Pre-Visit-Forms_Exit-Warning-Message_Unsaved"
        transform="translate(-170.000000, -501.000000)"
        fill="#004394"
      >
        <g id="Modal-Popop-/-Two-Buttons" transform="translate(-0.000000, 0.000000)">
          <g id="Modal" transform="translate(0.000000, 465.000000)">
            <g id="Icons-/-Information-/-Solid" transform="translate(170.000000, 36.000000)">
              <g id="Icons-/-Information-/-Outline" fillRule="nonzero">
                <g id="Icons-/-Information-/-Solid">
                  <path
                    d="M18,0 C27.9411255,0 36,8.0588745 36,18 C36,27.9411255 27.9411255,36 18,36 C8.0588745,36 0,27.9411255 0,18 C0,8.0588745 8.0588745,0 18,0 Z M18,2 C9.163444,2 2,9.163444 2,18 C2,26.836556 9.163444,34 18,34 C26.836556,34 34,26.836556 34,18 C34,9.163444 26.836556,2 18,2 Z"
                    id="Oval"
                  ></path>
                </g>
              </g>
              <path
                d="M18.25,26 C17.5594785,26 17,26.5604245 17,27.2513739 C17,27.9423234 17.5594785,28.5027479 18.25,28.5027479 C18.9405215,28.5027479 19.5,27.9423234 19.5,27.2513739 C19.5,26.5604245 18.9405215,26 18.25,26 Z"
                id="Oval"
              ></path>
              <path
                d="M18.2,7 C18.7128358,7 19.1355072,7.38604019 19.1932723,7.88337887 L19.2,8 L19.2,23 C19.2,23.5522847 18.7522847,24 18.2,24 C17.6871642,24 17.2644928,23.6139598 17.2067277,23.1166211 L17.2,23 L17.2,8 C17.2,7.44771525 17.6477153,7 18.2,7 Z"
                id="Line-2"
              ></path>
            </g>
          </g>
        </g>
      </g>
    </g>
  ),
  viewBox: '0 0 36 36'
};
